let id = 0

export function uniqueId(prefix: string = ''): string {
  return `${prefix}${id++}`
}



// WEBPACK FOOTER //
// ./src/utils/uniqueId.ts